import Header from "./components/Header";
import HeroSeven from "./hero/HeroSeven";
import FeaturesTwo from "./features/FeaturesTwo";
import StatsOne from "./stats/StatsOne";
import AssetsTwo from "./assets/AssetsTwo";
import CTAThree from "./cta/CTAThree";
import FooterEight from "./footer/FooterEight";
import { useEffect } from "react";
import TestimonialsOne from "./testimonials/TestimonialsOne";
import HeaderWhite from "./components/HeaderWhite";
import CTAOne from "./cta/CTAOne";
import PricingOne from "./pricing/PricingOne";
import FooterThree from "./footer/FooterThree";

const Main = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeroSeven />
      <FeaturesTwo />
      <StatsOne />
      <AssetsTwo />
      {/* <TestimonialsOne /> */}
      {/* <PricingOne /> */}
      {/* <CTAOne /> */}
      <FooterEight />
    </>
  );
};

export default Main;
